var _defs, _g, _g2, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAntlogyHomeGridIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 800,
    zoomAndPan: "magnify",
    viewBox: "0 0 600 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "42ba5cbc0b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 29.777344 21.734375 L 191 21.734375 L 191 172.476562 L 29.777344 172.476562 Z M 29.777344 21.734375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f28d03c406"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 52.277344 21.734375 L 168.4375 21.734375 C 174.402344 21.734375 180.125 24.105469 184.347656 28.324219 C 188.566406 32.542969 190.9375 38.265625 190.9375 44.234375 L 190.9375 149.976562 C 190.9375 155.945312 188.566406 161.667969 184.347656 165.886719 C 180.125 170.109375 174.402344 172.476562 168.4375 172.476562 L 52.277344 172.476562 C 46.308594 172.476562 40.585938 170.109375 36.367188 165.886719 C 32.148438 161.667969 29.777344 155.945312 29.777344 149.976562 L 29.777344 44.234375 C 29.777344 38.265625 32.148438 32.542969 36.367188 28.324219 C 40.585938 24.105469 46.308594 21.734375 52.277344 21.734375 Z M 52.277344 21.734375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "02cf3c81f4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.777344 0.734375 L 162 0.734375 L 162 151.476562 L 0.777344 151.476562 Z M 0.777344 0.734375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c189c9bde1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 23.277344 0.734375 L 139.4375 0.734375 C 145.402344 0.734375 151.125 3.105469 155.347656 7.324219 C 159.566406 11.542969 161.9375 17.265625 161.9375 23.234375 L 161.9375 128.976562 C 161.9375 134.945312 159.566406 140.667969 155.347656 144.886719 C 151.125 149.109375 145.402344 151.476562 139.4375 151.476562 L 23.277344 151.476562 C 17.308594 151.476562 11.585938 149.109375 7.367188 144.886719 C 3.148438 140.667969 0.777344 134.945312 0.777344 128.976562 L 0.777344 23.234375 C 0.777344 17.265625 3.148438 11.542969 7.367188 7.324219 C 11.585938 3.105469 17.308594 0.734375 23.277344 0.734375 Z M 23.277344 0.734375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "1c45db91fa"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 162,
    y: 0,
    height: 152
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f6c6d35f9c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 220.9375 21.734375 L 379.0625 21.734375 L 379.0625 353.429688 L 220.9375 353.429688 Z M 220.9375 21.734375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "9c6e624cfa"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 243.4375 21.734375 L 356.5625 21.734375 C 362.53125 21.734375 368.253906 24.105469 372.472656 28.324219 C 376.691406 32.542969 379.0625 38.265625 379.0625 44.234375 L 379.0625 330.765625 C 379.0625 336.734375 376.691406 342.457031 372.472656 346.675781 C 368.253906 350.894531 362.53125 353.265625 356.5625 353.265625 L 243.4375 353.265625 C 237.46875 353.265625 231.746094 350.894531 227.527344 346.675781 C 223.308594 342.457031 220.9375 336.734375 220.9375 330.765625 L 220.9375 44.234375 C 220.9375 38.265625 223.308594 32.542969 227.527344 28.324219 C 231.746094 24.105469 237.46875 21.734375 243.4375 21.734375 Z M 243.4375 21.734375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "deaa0fab68"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.9375 0.734375 L 159.0625 0.734375 L 159.0625 332.28125 L 0.9375 332.28125 Z M 0.9375 0.734375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "92c30a7b69"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 23.4375 0.734375 L 136.5625 0.734375 C 142.53125 0.734375 148.253906 3.105469 152.472656 7.324219 C 156.691406 11.542969 159.0625 17.265625 159.0625 23.234375 L 159.0625 309.765625 C 159.0625 315.734375 156.691406 321.457031 152.472656 325.675781 C 148.253906 329.894531 142.53125 332.265625 136.5625 332.265625 L 23.4375 332.265625 C 17.46875 332.265625 11.746094 329.894531 7.527344 325.675781 C 3.308594 321.457031 0.9375 315.734375 0.9375 309.765625 L 0.9375 23.234375 C 0.9375 17.265625 3.308594 11.542969 7.527344 7.324219 C 11.746094 3.105469 17.46875 0.734375 23.4375 0.734375 Z M 23.4375 0.734375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b6416fb2e1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 160,
    y: 0,
    height: 333
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b743a52968"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 409.0625 21.734375 L 570.222656 21.734375 L 570.222656 353.496094 L 409.0625 353.496094 Z M 409.0625 21.734375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "901c9a1e01"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 431.5625 21.734375 L 547.722656 21.734375 C 553.691406 21.734375 559.414062 24.105469 563.632812 28.324219 C 567.851562 32.542969 570.222656 38.265625 570.222656 44.234375 L 570.222656 330.765625 C 570.222656 336.734375 567.851562 342.457031 563.632812 346.675781 C 559.414062 350.894531 553.691406 353.265625 547.722656 353.265625 L 431.5625 353.265625 C 425.597656 353.265625 419.875 350.894531 415.652344 346.675781 C 411.433594 342.457031 409.0625 336.734375 409.0625 330.765625 L 409.0625 44.234375 C 409.0625 38.265625 411.433594 32.542969 415.652344 28.324219 C 419.875 24.105469 425.597656 21.734375 431.5625 21.734375 Z M 431.5625 21.734375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fd7b919201"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.0625 0.734375 L 161.222656 0.734375 L 161.222656 332.28125 L 0.0625 332.28125 Z M 0.0625 0.734375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e4cf7b7fd6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 22.5625 0.734375 L 138.722656 0.734375 C 144.691406 0.734375 150.414062 3.105469 154.632812 7.324219 C 158.851562 11.542969 161.222656 17.265625 161.222656 23.234375 L 161.222656 309.765625 C 161.222656 315.734375 158.851562 321.457031 154.632812 325.675781 C 150.414062 329.894531 144.691406 332.265625 138.722656 332.265625 L 22.5625 332.265625 C 16.597656 332.265625 10.875 329.894531 6.652344 325.675781 C 2.433594 321.457031 0.0625 315.734375 0.0625 309.765625 L 0.0625 23.234375 C 0.0625 17.265625 2.433594 11.542969 6.652344 7.324219 C 10.875 3.105469 16.597656 0.734375 22.5625 0.734375 Z M 22.5625 0.734375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "4ff637c794"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 162,
    y: 0,
    height: 333
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "4ca4513150"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 29.777344 202.523438 L 191 202.523438 L 191 353.265625 L 29.777344 353.265625 Z M 29.777344 202.523438 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "5e1a1a9028"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 52.277344 202.523438 L 168.4375 202.523438 C 174.402344 202.523438 180.128906 204.890625 184.347656 209.113281 C 188.566406 213.332031 190.9375 219.054688 190.9375 225.023438 L 190.9375 330.765625 C 190.9375 336.734375 188.566406 342.457031 184.347656 346.675781 C 180.128906 350.894531 174.402344 353.265625 168.4375 353.265625 L 52.277344 353.265625 C 46.308594 353.265625 40.585938 350.894531 36.367188 346.675781 C 32.148438 342.457031 29.777344 336.734375 29.777344 330.765625 L 29.777344 225.023438 C 29.777344 219.054688 32.148438 213.332031 36.367188 209.113281 C 40.585938 204.890625 46.308594 202.523438 52.277344 202.523438 Z M 52.277344 202.523438 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "db13aed628"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.777344 0.523438 L 162 0.523438 L 162 151.265625 L 0.777344 151.265625 Z M 0.777344 0.523438 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a9fc7950f0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 23.277344 0.523438 L 139.4375 0.523438 C 145.402344 0.523438 151.128906 2.890625 155.347656 7.113281 C 159.566406 11.332031 161.9375 17.054688 161.9375 23.023438 L 161.9375 128.765625 C 161.9375 134.734375 159.566406 140.457031 155.347656 144.675781 C 151.128906 148.894531 145.402344 151.265625 139.4375 151.265625 L 23.277344 151.265625 C 17.308594 151.265625 11.585938 148.894531 7.367188 144.675781 C 3.148438 140.457031 0.777344 134.734375 0.777344 128.765625 L 0.777344 23.023438 C 0.777344 17.054688 3.148438 11.332031 7.367188 7.113281 C 11.585938 2.890625 17.308594 0.523438 23.277344 0.523438 Z M 23.277344 0.523438 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "2b50b22d22"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 162,
    y: 0,
    height: 152
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#42ba5cbc0b)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f28d03c406)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 29, 21)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#1c45db91fa)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#02cf3c81f4)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c189c9bde1)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 0.777344 0.734375 L 162.121094 0.734375 L 162.121094 151.476562 L 0.777344 151.476562 Z M 0.777344 0.734375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f6c6d35f9c)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#9c6e624cfa)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 220, 21)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b6416fb2e1)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#deaa0fab68)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#92c30a7b69)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 0.9375 0.734375 L 159.0625 0.734375 L 159.0625 332.429688 L 0.9375 332.429688 Z M 0.9375 0.734375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b743a52968)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#901c9a1e01)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 409, 21)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#4ff637c794)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#fd7b919201)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e4cf7b7fd6)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 0.0625 0.734375 L 161.222656 0.734375 L 161.222656 332.496094 L 0.0625 332.496094 Z M 0.0625 0.734375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#4ca4513150)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#5e1a1a9028)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 29, 202)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#2b50b22d22)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#db13aed628)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a9fc7950f0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 0.777344 0.523438 L 162.121094 0.523438 L 162.121094 151.265625 L 0.777344 151.265625 Z M 0.777344 0.523438 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAntlogyHomeGridIcon1);
export default __webpack_public_path__ + "static/media/antlogyHomeGridIcon1.fa141d5fd90d892784b553385651a8f4.svg";
export { ForwardRef as ReactComponent };